<template>
  <div id="office">
    <rich-text v-if="page" :elements="page.document.content" :is-root="true"></rich-text>
  </div>
</template>

<script>
import RichText from '@/components/RichText.vue';

export default {
  name: 'office',
  props: ['page'],
  components: {
    RichText,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang='sass'>
  #office
    .introduction
      padding-bottom: 6rem
      .column
        position: relative
        padding: 3rem 0 !important
        &:first-child
          width: 33%
          text-align: right
        &:last-child
          position: relative
          width: 66%
          &::after
            position: absolute
            content: ""
            top: 0
            right: -50%
            height: 316%
            width: 180%
            background-color: #ecf1f4
            z-index: -1
        h2
          position: relative
          display: inline-block
          margin-right: 8rem
          &::after
            content: ""
            position: absolute
            right: 0
            bottom: -1rem
            display: block
            height: 4px
            width: 1500px
            background-color: #fe3904

    .history
      .image
        margin: 0 5rem 0 -20%
        z-index: 0
      .columns
        .column
          &:first-child
            padding: 0
            z-index: 0
            figure
              height: 100%
            img
              height: 100%
              object-fit: cover
          &:last-child
            z-index: 1
            h2, figure
              margin-top: 5%
            figure
              padding: 0
              margin: 1rem 0 3rem 0
              height: 4px
              width: 10%
              background-color: #fe3904

    .numbers
      h2
        margin-top: 16rem
      .columns
        flex-wrap: wrap
      .column
        flex: 1 0 25%
        justify-content: center
      img
        margin: 1rem auto
        max-height: 120px
      b
        display: block
        margin: 0.5rem 0
        color: #0e6faa
        font-weight: 600
        text-align: center
      .text
        text-align: center

    .organisation-title
      margin-top: 6rem
      padding-top: 4rem
      background-color: #ecf1f4
      text-align: center
    .organisation
      padding: 2rem 0
      margin: 0 !important
      background-color: #ecf1f4
      h2
        margin-top: 6rem
      .column
        &:first-child
          padding: 8rem 4rem 0 0
          .text
            position: relative
            padding: 3rem 1rem 3rem 1rem
            &:before
              content: "\F054"
              position: absolute
              top: 50%
              left: -36px
              display: inline-block
              margin-top: -18px
              font: normal normal normal 24px/1 "Material Design Icons"
              font-size: 28px
              color: #fe3904
              text-rendering: auto
              line-height: inherit
              -webkit-font-smoothing: antialiased
        &:last-child
          transform: scale(1.2)

    .metrics
      padding: 2rem 0 6rem
      background-color: #ecf1f4
      .column
        width: 25%
        text-align: center
      .element, .element > *
        display: inline-block
      .element:nth-child(2)
        transform: translateY(-40px)
        font-size: 5rem
        font-weight: 200
      img
        height: 120px
      .element.metrics-label
        display: block

  @media screen and (max-width: 950px)
    #office
      .introduction
        padding: 2rem
      .metrics .column
        width: 100%
</style>
